export default {
	path: '/user',
	children: [
		{
			path: 'auth',
			name: 'AuthenticatePage',
			component: () => import('../pages/auth.vue'),
			meta: {
				publicOnly: true,
				title: 'user.loginRegister'
			}
		},
		{
			path: 'credentials',
			name: 'CredentialsPage',
			component: () => import('../pages/credentials.vue'),
			meta: {
				title: 'shared.completeCredentials',
				layout: 'app-bar'
			}
		}
	]
}
